// Service for the Attendance Dashboard "Mi equipo" — "Situación de asistencia" card
// (ASIS-5404 / REXASIS-003).
// GET /attendance/my-team/today/attendance-summary?companyIds=1,2&employeeIds=10,15 —
// both query params are optional CSV lists; omitted/[] means "Todos" (no filter),
// scoped to the Empresa/Colaborador filters of the "Mi equipo" dashboard.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetTodayAttendanceSummaryOut,
  GetMyTeamAttendanceSummaryParams,
  MyTeamAttendanceSummary,
} from '../types/myTeamAttendanceSummary.types';
import { mapMyTeamAttendanceSummary } from '../mappers/myTeamAttendanceSummary.mapper';


export class MyTeamAttendanceSummaryService {
  async getSummary(
    params?: GetMyTeamAttendanceSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamAttendanceSummary>> {
    const query = buildQueryString({
      companyIds: params?.companyIds?.map(String),
      employeeIds: params?.employeeIds?.map(String),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_TODAY_ATTENDANCE_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetTodayAttendanceSummaryOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamAttendanceSummary(response.data) };
  }
}

export const myTeamAttendanceSummaryService = new MyTeamAttendanceSummaryService();
